// Studyo Today Backend
// Package studyo.today.schools.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/schools/v1/resources/daily_workload.proto (package studyo.today.schools.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_type_date } from "@buf/googleapis_googleapis.bufbuild_es/google/type/date_pb.js";
import { file_studyo_today_schools_v1_resources_workload_group } from "./workload_group_pb.js";
import { file_studyo_today_schools_v1_resources_workload_summary } from "./workload_summary_pb.js";

/**
 * Describes the file studyo/today/schools/v1/resources/daily_workload.proto.
 */
export const file_studyo_today_schools_v1_resources_daily_workload = /*@__PURE__*/
  fileDesc("CjZzdHVkeW8vdG9kYXkvc2Nob29scy92MS9yZXNvdXJjZXMvZGFpbHlfd29ya2xvYWQucHJvdG8SIXN0dWR5by50b2RheS5zY2hvb2xzLnYxLnJlc291cmNlcyK3AQoNRGFpbHlXb3JrbG9hZBIfCgRkYXRlGAEgASgLMhEuZ29vZ2xlLnR5cGUuRGF0ZRJDCgdzdW1tYXJ5GAIgASgLMjIuc3R1ZHlvLnRvZGF5LnNjaG9vbHMudjEucmVzb3VyY2VzLldvcmtsb2FkU3VtbWFyeRJACgZncm91cHMYAyADKAsyMC5zdHVkeW8udG9kYXkuc2Nob29scy52MS5yZXNvdXJjZXMuV29ya2xvYWRHcm91cEIpqgImU3R1ZHlvLlRvZGF5LlNjaG9vbHMuR3JwYy5WMS5SZXNvdXJjZXNiBnByb3RvMw", [file_google_type_date, file_studyo_today_schools_v1_resources_workload_group, file_studyo_today_schools_v1_resources_workload_summary]);

/**
 * Describes the message studyo.today.schools.v1.resources.DailyWorkload.
 * Use `create(DailyWorkloadSchema)` to create a new message.
 */
export const DailyWorkloadSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schools_v1_resources_daily_workload, 0);

